<template>
    <b-modal
      size="md"
      :hideFooter="true"
      :hideHeader="true"
      id="confirmPasswordResetModal"
    >
      <template slot="default">
        <b-row>
          <b-col class="float-left">
            <em class="fas fa-lg fa-exclamation"></em>
          </b-col>
        </b-row>
        <b-container class="confirm-modal-cnt">
          <b-row class="text-center">
            <h6 class="confirm-modal-text">
              Вы действительно хотите сбросить пароль данному пользователю?
            </h6>
          </b-row>
          <b-row class="text-center ">
            <h5 class="resetName">
              {{ this.resetSurname }} {{ this.resetName }} {{ this.resetMidname }}
            </h5>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
              <b-button @click="resetPassword" class="confirm-modal-btn" variant="primary">
                Сбросить
              </b-button>
            </b-col>
            <b-col sm="12" md="6">
              <b-button @click="closeModal" class="confirm-modal-btn" variant="outline-primary">
                Отмена
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
</template>

<script>

import { mapActions } from 'vuex'
import usersApi from '@/api/users'

export default {
  name: 'ConfirmPasswordResetModal',
  props: {
    name: {
      type: String,
      default() {
        return ''
      }
    },
    surname: {
      type: String,
      default() {
        return ''
      }
    },
    midname: {
      type: String,
      default() {
        return ''
      }
    },
    id: {
      type: Number,
      default() {
        return null
      }
    }
  },
  computed: {
    resetName: {
      get() {
        return this.name
      },
      set() {
        this.name = this.$props.name
      }
    },
    resetSurname: {
      get() {
        return this.surname
      },
      set() {
        this.surname = this.$props.surname
      }
    },
    resetMidname: {
      get() {
        return this.midname
      },
      set() {
        this.midname = this.$props.midname
      }
    },
    resetId: {
      get() {
        return this.id
      },
      set() {
        this.id = this.$props.id
      }
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('confirmPasswordResetModal')
    },
    resetPassword() {
      usersApi.resetPassword({ id: this.resetId })
        .then(() => {
          this.closeModal()
          this.pushToasts({
            title: 'Успешный сброс пароля',
            message: 'Пользователю была выслана ссылка для установления нового пароля!',
            time: 3
          })
        })
        .catch(() => {
        })
    },
    ...mapActions('toasts', [
      'pushToasts'
    ])
  }
}
</script>

<style scoped lang="scss">

  .confirm-modal-btn {
    width: 100%;
  }

  .confirm-modal-text {
    margin-bottom: 20px;
  }

  .resetName {
    width: 100%;
    margin-bottom: 20px;
  }

</style>
